import React, { useEffect, useState } from 'react'
import classes from './PageNotFound.module.css'

const PageNotFound = () => {
  const [mouseCoordinates, setMouseCoordinates] = useState({x:600, y:250});
	
  	const mouseMoveHandler = (event) => {
    	setMouseCoordinates({
      		x:event.clientX,
      		y:event.clientY
    	});
  	}
    useEffect(()=>{
    	window.addEventListener('mousemove', mouseMoveHandler);
    	return(()=>{
      		window.removeEventListener('mousemove', mouseMoveHandler);
    	})
  	}, []) 
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const setWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    window.addEventListener( 'resize',setWidth)

    return (() => {
      window.removeEventListener('resize',setWidth)
    })
  },[windowWidth])
  return (
    <div className={classes.container}>
      <div className="text">
        <h1 className={classes.texth1}>404</h1>
        <h2 className={classes.texth2}>Page not Found</h2>
        {windowWidth > 996 && <h3 className={classes.texth3}>
          Sorry we cant find what you are looking for 'cuz its so dark in here
        </h3>}
      </div>
      {windowWidth > 996 && <div className={classes.torch} style={{top:mouseCoordinates.y, left:mouseCoordinates.x}}></div>}
    </div>
  );
}

export default PageNotFound
